import { fetchCatalogsIfNeeded, getCatalog, getCatalogPreview } from '@/redux/modules/catalog';
import caseInsensitiveCompare from '@liveauctioneers/caterwaul-components/lib/utils/caseInsensitiveCompare';
import { DataLoaderParams } from '@/types/DataLoaderParams';
import { fetchCatalogItemModels } from '@/redux/modules/catalogItems';
import { fetchDataForCatalogPage } from '@/redux/modules/catalogPage';
import { fetchItemCardModelsIfNeeded } from '@/redux/modules/itemCardModel';
import { FetchItemsCardModelsByCatalogIdQueryType } from '@/redux/api/itemCardModel';
import { fetchLiveCatalogRegistrationIfNeeded } from '@/redux/modules/catalogRegistration';
import { getIdFromPath } from '@/utils/urls';
import { getPaginationPageSize } from '@/redux/modules/pagination';
import { isUserLoggedIn } from '@/redux/modules/user';
import { parseQueryParams } from '@/utils/queryParams';
import TEST_HOUSES from '@/utils/testHouses';

interface QueryParams {
    buyNow?: string;
    keyword?: string;
    page?: string;
    pageSize?: string;
    sort?: string;
}

export default ({ location, store }: DataLoaderParams) => {
    const params: QueryParams = parseQueryParams(location.search);
    const { pathname } = location;
    const { dispatch } = store;
    const catalogId = getIdFromPath(pathname);

    if (!catalogId) {
        return Promise.resolve();
    }

    return Promise.all([dispatch(fetchCatalogsIfNeeded([catalogId]))]).then(() => {
        const state = store.getState();
        const preview = getCatalogPreview(state, catalogId);
        const { coverLots, sellerId } = getCatalog(state, catalogId);
        const loggedIn = isUserLoggedIn(state);

        const globalPageSize = getPaginationPageSize(state);
        const page = Number(params.page || 1);
        let pageSize = globalPageSize || 24;
        if (caseInsensitiveCompare(params?.pageSize, 'all')) {
            pageSize = 'all';
        } else if (!isNaN(Number(params.pageSize))) {
            pageSize = Number(params.pageSize);
        }

        // handle NaN
        const keyword = params.keyword || '';
        const sort = params.sort || 'lotNumber';
        const buyNow = params.buyNow !== 'false' && typeof params.buyNow !== 'undefined';

        const query: FetchItemsCardModelsByCatalogIdQueryType = { buyNow, keyword, page, pageSize, sort };
        if (preview || TEST_HOUSES.includes(sellerId)) {
            query.preview = true;
        }

        const itemIds = coverLots.map((cl) => cl.itemId);

        const promises = [
            dispatch(fetchDataForCatalogPage(catalogId)),
            dispatch(fetchItemCardModelsIfNeeded(itemIds, 'catalog-cover-items-for-quickload')),
            dispatch(fetchCatalogItemModels({ catalogId, query })),
        ];

        if (loggedIn) {
            promises.push(fetchLiveCatalogRegistrationIfNeeded(catalogId, sellerId));
        }

        return Promise.all(promises);
    });
};
